export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const preventOrphanWords = (text) => {
  const words = text.split(' ');
  if (words.length < 3) return text;  // Only apply to 3 or more words
  return [...words.slice(0, -2), words.slice(-2).join('\u00A0')].join(' ');
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric'
  });
};

export const formatAddedDate = (dateString) => {
  const date = new Date(dateString);
  const month = (date.getMonth() + 1).toString(); // getMonth() returns 0-11
  const day = date.getDate().toString();
  const year = date.getFullYear().toString().slice(-2); // Get last 2 digits
  return `Added ${month}/${day}/${year}`;
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
};